/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import LegalbirdLoader from "../ContentLoader/LegalbirdLoader";
import _map from "lodash/map";
import _slice from "lodash/slice";
import Button from "@mui/material/Button";
import { KeyboardArrowDown, KeyboardArrowUp, Refresh } from "@mui/icons-material";
import { fetchCollection, queryKeys } from "../../services/reactQuery/reactQueryService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { List, ListItem, Typography } from "@mui/material";
import MediaObjectRow from "../MediaObject/MediaObjectRow";

type DocumentsProps = {
  product: AbstractCase;
};

const Documents = ({ product }: DocumentsProps) => {
  const queryClient = useQueryClient();
  const [showAll, setShowAll] = useState(false);
  const urlParams = { product: product.name, productId: product.id };
  const mediaObjectCollectionKey = queryKeys.collection("/media_objects", urlParams);
  const { data: mediaObjectsCollection } = useQuery({
    queryKey: mediaObjectCollectionKey,
    queryFn: () => fetchCollection("/media_objects", urlParams),
  });
  const moreDocumentsThreshold = 2;

  const fetchMediaObjectCollection = () =>
    queryClient.invalidateQueries({
      queryKey: mediaObjectCollectionKey,
    });

  if (!product || !mediaObjectsCollection) {
    return <LegalbirdLoader />;
  }

  if (mediaObjectsCollection.length < 1) {
    return (
      <>
        <Typography sx={{ marginBottom: "0.5rem" }}>Bisher sind noch keine Dokumente vorhanden</Typography>
        <Button onClick={fetchMediaObjectCollection} endIcon={<Refresh />} sx={{ paddingLeft: 0 }}>
          Aktualisieren
        </Button>
      </>
    );
  }

  const mediaObjects = showAll ? mediaObjectsCollection : _slice(mediaObjectsCollection, 0, moreDocumentsThreshold);

  return (
    <>
      <List>
        {_map(mediaObjects, (mediaObject, idx) => {
          return (
            <ListItem key={mediaObject.id} disablePadding divider>
              <MediaObjectRow mediaObject={mediaObject} />
            </ListItem>
          );
        })}
      </List>
      {mediaObjectsCollection.length > moreDocumentsThreshold && (
        <Button
          sx={{ paddingLeft: 0 }}
          onClick={() => {
            setShowAll(!showAll);
          }}
          endIcon={showAll ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        >
          {showAll ? "Weniger anzeigen" : "Mehr anzeigen"}
        </Button>
      )}
    </>
  );
};

export default Documents;
